import React from "react";

/**
 * Client logos (cropped & extracted from the official Pegasus Infra profile).
 * Stored as static assets in /public/clients/. We render them monochrome
 * (grayscale + invert) so every mark reads cleanly against the dark theme
 * regardless of its original brand colour, and fade from 60% to 100% opacity
 * on hover for a subtle, premium reveal.
 */
const CLIENTS = [
  { name: "Coca-Cola", src: "/clients/10-coca-cola.png" },
  { name: "Raymond", src: "/clients/11-raymond.png" },
  { name: "Timken", src: "/clients/07-timken.png" },
  { name: "Bovis Lend Lease", src: "/clients/03-bovis.png" },
  { name: "AUMA", src: "/clients/05-auma.png" },
  { name: "MTC Group", src: "/clients/04-mtc-group.png" },
  { name: "Reitzel India", src: "/clients/06-reitzel.png" },
  { name: "Sunvik Steel", src: "/clients/12-sunvik.png" },
  { name: "SK Super TMT Steel", src: "/clients/08-sk-super-tmt.png" },
  { name: "LM Glasfiber", src: "/clients/09-lm-glasfiber.png" },
  { name: "Silver Spark", src: "/clients/02-silver-spark.png" },
  { name: "Texport", src: "/clients/13-texport.png" },
  { name: "Kunigal Valley International Residential School", src: "/clients/01-kunigal-valley.png" },
];

export default function Clients() {
  return (
    <section
      id="projects"
      className="relative py-24 md:py-28 bg-[#0A0A0A] border-t border-white/5"
      data-testid="clients-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-14 text-center">
        <div className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37] mb-5">
          Trusted Clientele
        </div>
        <h2 className="font-serif text-4xl md:text-5xl text-white leading-tight">
          Delivering for India’s{" "}
          <span className="italic text-[#D4AF37]">most considered</span> brands.
        </h2>
      </div>

      <div
        className="pg-marquee relative overflow-hidden border-y border-white/5 py-10"
        data-testid="clients-marquee"
      >
        <div className="pg-marquee-track flex items-center gap-14 md:gap-20 whitespace-nowrap w-max px-8">
          {[...CLIENTS, ...CLIENTS].map((c, i) => (
            <div
              key={i}
              className="flex items-center gap-14 md:gap-20 shrink-0"
            >
              <img
                src={c.src}
                alt={c.name}
                title={c.name}
                loading="lazy"
                draggable="false"
                className="h-14 md:h-16 w-auto max-w-[260px] md:max-w-[320px] object-contain shrink-0 opacity-60 hover:opacity-100 transition-opacity duration-500 pointer-events-none select-none"
                style={{ filter: "grayscale(1) brightness(1) invert(1)" }}
              />
              <span className="w-1.5 h-1.5 bg-[#D4AF37]/50 rounded-full shrink-0" />
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
          {[
            {
              n: "120+",
              l: "Projects Delivered",
              d: "Across five core sectors over 24+ years.",
            },
            {
              n: "98%",
              l: "On-time Handover",
              d: "A track record of discipline and predictability.",
            },
            {
              n: "Zero",
              l: "Compromise",
              d: "On structural integrity, cost discipline or clarity.",
            },
          ].map((s) => (
            <div
              key={s.l}
              className="bg-[#0A0A0A] p-10 pg-hover-lift"
              data-testid={`stat-${s.l.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-serif text-5xl text-[#D4AF37] mb-3">
                {s.n}
              </div>
              <div className="text-white font-serif text-xl mb-2">{s.l}</div>
              <div className="text-sm text-[#A3A3A3]">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
